import { JSX, use, useMemo, Suspense } from 'react'

import { Box, HStack, VStack, StackProps, Image, Heading, Text } from '@chakra-ui/react'


import { HttpBody } from '@/lib/request'

import * as locally from '@/lib/locally.js'

import * as company_storage from '@/storage/company.js'


// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Loading from '@/components/ui/loading.tsx'

import logo from '/public/images/logo.png'




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Summary
(
	props: {
		name   : string
		created: string

	},

)
:	JSX.Element
{
	return (
		<HStack p="4" gap="4">
			<Image boxSize="16" src={logo} />

			<VStack gap="0" alignItems="flex-start">
				<Heading size="2xl">{props.name}</Heading>

				<Text as="span" color="fg.subtle" fontSize="sm">{`创建于: ${locally.date(props.created)}`}</Text>

			</VStack>

		</HStack>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Dataset
(
	props: StackProps
			& {
				contract: number
				recently: number
				overdued: number
				resigned: number

			},

)
:	JSX.Element
{
	return (
		<HStack px="24" py="4" gap="4" {...props}>
			<VStack w="1/5" alignItems="flex-start">
				<Text as="strong" fontSize="xl">{props.contract}</Text>
				<Text as="span" color="fg.subtle" fontSize="sm">在职员工</Text>
			</VStack>

			<VStack w="1/5" alignItems="flex-start">
				<Text as="strong" fontSize="xl">{props.recently}</Text>
				<Text as="span" color="fg.subtle" fontSize="sm">最新入职</Text>
			</VStack>

			<VStack w="1/5" alignItems="flex-start">
				<Text as="strong" fontSize="xl">{props.overdued}</Text>
				<Text as="span" color="fg.subtle" fontSize="sm">协议到期</Text>
			</VStack>

			<VStack w="1/5" alignItems="flex-start">
				<Text as="strong" fontSize="xl">{props.resigned}</Text>
				<Text as="span" color="fg.subtle" fontSize="sm">归档合同</Text>
			</VStack>
		</HStack>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Retrieve
(
	props: {
		doc: Promise<HttpBody<company_storage.TRawDocumentType> >

	},

)
:	JSX.Element
{
	let doc = use(props.doc)

	return (
		<Box h="48" flexShrink="0">
			<Summary name={doc.name} created={doc.created} />

			<Dataset
				contract={doc.contract_quantity || 0}
				recently={doc.recently_quantity || 0}
				overdued={doc.overdued_quantity || 0}
				resigned={doc.resigned_quantity || 0}

			/>

		</Box>

	)

}



export default function
(
	props: {
		_id: string

	},

)
:	JSX.Element
{
	let doc = useMemo(
		() => company_storage.retrieve(props._id),

		[props._id],

	)

	return (
		<Suspense fallback={<Loading.Default h="48" flexShrink="0" />}>
			<Retrieve doc={doc} />

		</Suspense>

	)

}
